<template>
  <v-container id="axis-list">
    <v-row>
      <v-col cols="12" md="12" class="breadcrumbs">
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="8" offset-sm="4">
        <div class="text-right">
          <div cols="10" md="1">
            <app-modal-import-group-solution
              :color="'success'"
              :icon="'mdi-plus-circle'"
              @onSave="loadAxis()"
            >
              <template v-slot:title>
                Importação de
                {{ isAT ? "Grupo de Iniciativa" : "Grupo de Solução" }}
              </template>
            </app-modal-import-group-solution>

            <app-modal-insert-axis
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              @onSave="loadAxis()"
            >
              <template v-slot:title>
                Cadastramento de
                {{ isAT ? "Grupo de Iniciativa" : "Grupo de Solução" }}
              </template>
            </app-modal-insert-axis>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="axisActive"
          item-key="name"
          class="elevation-1"
          :footer-props="{ itemsPerPageText: 'Itens por página' }"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-xs-right pa-4" :title="item.nome">
                {{ formatTableValues(item.nome) }}
              </td>
              <td class="text-xs-right pa-4" :title="item.descricao">
                {{ formatTableValues(item.descricao) }}
              </td>
              <td class="text-xs-right pa-4">
                <v-row>
                  <v-col cols="1">
                    <app-modal-insert-axis
                      :object="item"
                      :edit="true"
                      :color="'warning'"
                      :icon="'mdi-pencil'"
                      @onSave="loadAxis"
                    >
                      <template v-slot:title>
                        Edição de
                        {{ isAT ? "Grupo de Iniciativa" : "Grupo de Solução" }}
                      </template>
                    </app-modal-insert-axis>
                  </v-col>

                  <v-col cols="1" class="col-min-width-bigger">
                    <app-modal-delete-axis :payload="item" @onDelete="loadAxis">
                      <template v-slot:title>
                        Deletar
                        {{ isAT ? "Grupo de Iniciativa" : "Grupo de Solução" }}
                      </template>
                    </app-modal-delete-axis>
                  </v-col>
                </v-row>
              </td>
            </tr>
          </template>
          <template v-slot:footer.page-text="items">
            {{ items.pageStart }} - {{ items.pageStop }} de
            {{ items.itemsLength }}
          </template>

          <template slot="no-data">
            <div class="progress" v-if="loading">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>

            <div v-else>
              Nenhum
              {{ isAT ? "Grupo de Iniciativa" : "Grupo de Solução" }} retornado
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <AppRetrieveGroupSolution
          :solutionsGroup="desactivatedAxis"
          @onRecover="loadAxis"
        >
        </AppRetrieveGroupSolution>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { cityGroupSolutionAPI } from "@/modules/city/API/CityGroupSolutionAPI";
import AppModalInsertAxis from "@/modules/axis/components/city/ModalInsert";
import AppModalImportGroupSolution from "@/modules/group-solution/components/city/ModalImport";
import AppModalDeleteAxis from "@/modules/axis/components/city/ModalDelete";
import AppRetrieveGroupSolution from "@/modules/axis/components/city/RetrieveSolutionGroup";
import { mapActions, mapGetters } from "vuex";
import { formatTableValues } from "@/modules/city/components/terms-reference/utils";

export default {
  name: "AppAxisList",
  props: {
    filter: { type: Object, required: true },
  },
  components: {
    AppModalInsertAxis,
    AppModalImportGroupSolution,
    AppModalDeleteAxis,
    AppRetrieveGroupSolution,
  },
  data() {
    return {
      headers: [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ],
      axisActive: [],
      desactivatedAxis: [],
      formatTableValues: formatTableValues,
      breadcrumbs: [
        {
          text: "Grupos de Soluções",
          disabled: true,
          href: "eixo",
        },
      ],
      loading: false,
    };
  },
  mounted() {
    if (this.isAT) {
      this.breadcrumbs = [
        {
          text: "Grupos de Iniciativas",
          disabled: true,
          href: "eixo",
        },
      ];
    }
    this.loadAxis();
  },
  watch: {
    filter: {
      handler(value) {
        this.loadAxis();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["isFullAdmin", "isAT"]),
  },
  methods: {
    ...mapActions(["setLoading", "reload"]),
    limpar() {
      this.axisActive = [];
      this.desactivatedAxis = [];
    },
    loadAxis() {
      this.limpar();

      var filtros = {
        grupoSolucaoId:
          this.filter.municipioGrupoSolucao &&
          this.filter.municipioGrupoSolucao.municipioGrupoSolucaoId,
        municipioId: this.$route.params.id,
      };
      this.loading = true;

      cityGroupSolutionAPI
        .listByCity(filtros)
        .then((resp) => {
          this.axisActive = resp.data.filter((item) => !item.desabilitado);
          this.desactivatedAxis = resp.data.filter((item) => item.desabilitado);
          this.$emit("reload");
          this.loading = false;
        })
        .catch((resp) => {
          this.loading = false;
          this.$notification.error(
            `Erro ao listar grupos de ${this.isAT ? "iniciativas" : "soluções"}`
          );
        });
    },
  },
};
</script>
